import React from 'react';
import PropTypes from 'prop-types';
const Link = ({ navigate, to, children }) => {
  const navigateTo = (pathname, state = {}) => navigate({ pathname, state });
  if (typeof children === 'string') {
    return (
      <a href={to} onClick={(e) => { e.preventDefault(); navigateTo(to); }}>{ children }</a>
    );
  }

  return React.cloneElement(
    children,
    { navigate: navigateTo, to }
  );
};

Link.propTypes = {
  navigate: PropTypes.func,
  to: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
};

export default Link;
